import { useContext, useState } from "react";
import { FaoBuilderContext } from "context/FaoBuilderContext";
import apiRoot from "../../../api/apiRoot";
import { toast } from "react-toastify";

function useAidResultsBuild(model, setModels, models) {
  const { pollJobRunStatus, aidResultsBuildStatus, aidResultsBuildDispatch } =
    useContext(FaoBuilderContext);

  const updateAidResults = async () => {
    const response = await apiRoot.post(
      "api/fao-model/aid-results",
      {},
      { params: { modelId: model.id } }
    );
    const updatedModel = response.data;
    setModels(models.map((m) => (m.id === model.id ? updatedModel : m)));
  };
  const getBuildJobStatus = async (runId) => {
    const response = await pollJobRunStatus(runId);
    return response;
  };

  const handleAidResultsBuild = async () => {
    // add the model to the build status
    aidResultsBuildDispatch({
      type: "build_found",
      modelId: model.id,
    });
    let buildError = null;
    const modelBuildStatus = aidResultsBuildStatus[model.id]?.status;
    try {
      if (modelBuildStatus === "building") {
        toast.error(
          "Aid results are already being built for the model: ",
          model.id
        );
        return false;
      }
      const response = await apiRoot.post(
        "/api/fao-model/build-aid-results",
        {},
        {
          params: { modelId: model.id },
        }
      );
      if (response.data.runStatus === "RUNNING") {
        const jobResponse = await getBuildJobStatus(response.data.runId);
        if (jobResponse.success) {
          await updateAidResults();
        } else {
          buildError = jobResponse.message;
        }
        return jobResponse.success;
      } else if (response.data.runStatus === "FAILURE") {
        buildError = response.data.message;
      }
      return false;
    } catch (error) {
      buildError = error.message;
      return false;
    } finally {
      aidResultsBuildDispatch({
        type: "build_complete",
        modelId: model.id,
        error: buildError,
      });
    }
  };
  return {
    handleAidResultsBuild,
  };
}

export default useAidResultsBuild;
